import { createAction, props } from '@ngrx/store';

export const loadUploadFactsheets = createAction('[UploadFactsheet] Load UploadFactsheets', props<{ request: any }>());

export const loadUploadFactsheetsSuccess = createAction('[UploadFactsheet] Load UploadFactsheets Success', props<{ response: any }>());

export const loadUploadFactsheetsFailure = createAction('[UploadFactsheet] Load UploadFactsheets Failure', props<{ error: any }>());
